import * as R from 'ramda';

const userMustHaveCommercialCode = user => {
  const sales = R.path(['extra', 'sales'], user);

  return R.propEq('role', 'reseau_commercial')(user) && R.includes(sales, ['MDE', 'Mdpro', 'VIASANTE']);
};

export default userMustHaveCommercialCode;
